var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18091 0V3.12207H9.00415V3.12402H5.15552C4.33123 3.13195 3.66431 3.82695 3.66431 4.68457V7.31348C3.66443 8.17099 4.33005 8.86577 5.15552 8.875H9.00415V8.87793H9.18091V12H5.32446C2.82617 12 0.800049 9.90187 0.800049 7.31445V4.68555C0.800049 2.09683 2.82617 0 5.32446 0H9.18091ZM6.7229 3.58594C6.75306 3.50264 6.86657 3.50264 6.89673 3.58594L7.17603 4.36914C7.38338 4.94831 7.82383 5.40341 8.38306 5.61816L9.13989 5.90918C9.21972 5.94069 9.2199 6.05756 9.13989 6.08887L8.38306 6.37891C7.82384 6.59365 7.38338 7.04877 7.17603 7.62793L6.89673 8.41211C6.86648 8.495 6.75327 8.49488 6.7229 8.41211L6.44263 7.62793C6.2353 7.04898 5.79554 6.59371 5.23657 6.37891L4.47974 6.08887C4.39932 6.05764 4.39934 5.94044 4.47974 5.90918L5.23657 5.61816C5.79556 5.40334 6.23533 4.94814 6.44263 4.36914L6.7229 3.58594Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClair);
export default __webpack_public_path__ + "static/media/clair.e88602bcf911fd92fdd53cfdfda3e8b1.svg";
export { ForwardRef as ReactComponent };